import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';
import {Node} from 'reactflow';

import {ProcessFlowchartEditorConfigurator} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorConfigurator';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {ProcessTaskSchemaGraphQL} from '../../../../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaGraphQL';
import {NODE_SECTION_TO_HEADER_TITLE, UserFacingNodeTypes} from '../processFlowchartConfigEditorConstants';
import {ProcessFlowchartNodeSection} from '../processFlowchartConfigEditorConstants';
import {NODE_SECTION_TO_RENDERER} from '../processFlowchartConfigEditorRegistry';
import {FlowchartOptions} from '../processFlowchartConfigEditorUtils';
import {ConfigurableTaskDefinitionGQL} from '../useAllSchemasById';

export interface NodeSidepanelSectionProps {
  section: ProcessFlowchartNodeSection;
  nodeTypes: Array<UserFacingNodeTypes>;
  addNodeToCanvas: (newNode: Node<unknown>) => void;
  taskDefinitionsForSidepanel: Array<ConfigurableTaskDefinitionGQL>;
  options: FlowchartOptions;
  searchQuery: string | null;
  rootTaskSchema: ProcessTaskSchemaGraphQL;
  flowchartEditorConfigurator: ProcessFlowchartEditorConfigurator;
}

/**
 * An expandable section of the sidepanel
 */
export function NodeSidepanelSection(props: NodeSidepanelSectionProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={css(styles.section)}>
      <div
        className={css(styles.header)}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <BenchlingIcon icon={isOpen ? 'chevron-down' : 'chevron-right'} className={css(styles.chevron)} />
        <span className={css(styles.title)}>{NODE_SECTION_TO_HEADER_TITLE[props.section]}</span>
      </div>
      {isOpen && NODE_SECTION_TO_RENDERER[props.section](props)}
    </div>
  );
}

const styles = StyleSheet.create({
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '6px',
    alignSelf: 'stretch',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    alignSelf: 'stretch',
    paddingTop: '16px',
    paddingLeft: '16px',
  },
  title: {
    color: Color.GRAY_700,
  },
  chevron: {
    color: Color.GRAY_500,
    width: '10px',
    height: '10px',
  },
});
